import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, map, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class ApiServiceService {

    url = 'https://api.open.fec.gov';
    ApiKey = '?api_key=NAgHgIaVioIU9FFUMpNyOyizg5CgMmL6wfwyuzys';
    urlSearch = this.url + '/v1/names/candidates/' + this.ApiKey;

    urlDetail1 = this.url + '/v1/candidate/';
    urlDetail2 = '/?sort_nulls_last=false&per_page=20&sort=name&api_key=DEMO_KEY&page=1&sort_null_only=false&sort_hide_null=false';

    urlDem = 'https://api.open.fec.gov/v1/candidates/?sort=name&party=DEM';
    urlRep = 'https://api.open.fec.gov/v1/candidates/?sort=name&party=REP';
    urlInd = 'https://api.open.fec.gov/v1/candidates/?sort=name&party=IND';
    urlCont = '&api_key=NAgHgIaVioIU9FFUMpNyOyizg5CgMmL6wfwyuzys&per_page=20&sort_nulls_last=false&election_year=2020&sort_hide_null=' +
        'false&sort_null_only=false&candidate_status=C&page=1&office=P';


    urlFilings1 = 'https://api.open.fec.gov/v1/candidate/';
    urlFilings2 = '/filings/?sort=-receipt_date&api_key=NAgHgIaVioIU9FFUMpNyOyizg5CgMmL6wfwyuzys&per_page=20&sort_nulls_last=' +
        'false&sort_hide_null=false&sort_null_only=false&page=1&office=P';

    urlCommitte = 'https://api.open.fec.gov/v1/candidate/';
    urlCommitte2 = '/committees/?committee_type=P&sort_nulls_last=false&api_key=NAgHgIaVioIU9FFUMpNyOyizg5CgMmL6wfwyuzys&sort_hide_null=' +
        'false&page=1&sort_null_only=false&per_page=20&sort=name';

    urlElections = this.url + '/v1/elections/' + this.ApiKey + '&page=1&office=president&election_full=true&sort_hide_null' +
        '=false&per_page=20&sort=-total_receipts&sort_nulls_last=false&sort_null_only=false&cycle=';

    constructor(private http: HttpClient) {
    }


    public getResultSearch(Name: string): Observable<object[]> {
        const url = `${this.urlSearch}&q=${Name}`;
        return this.http.get<object[]>(url).pipe(tap(_ => console.log('TEST')), map(res => res['results']));
    }

    public getDetailSearch(id: string): Observable<object> {
        const url = `${this.urlDetail1}${id}${this.urlDetail2}`;
        return this.http.get<object>(url).pipe(
            tap(_ => console.log('test'))
        );
    }

    public getListDem(): Observable<object[]> {
        const url = `${this.urlDem}${this.urlCont}`;
        return this.http.get<object[]>(url).pipe(tap(_ => console.log('TEST')));
    }

    public getListRep(): Observable<object[]> {
        const url = `${this.urlRep}${this.urlCont}`;
        return this.http.get<object[]>(url).pipe(tap(_ => console.log('TEST')));
    }

    public getListInd(): Observable<object[]> {
        const url = `${this.urlInd}${this.urlCont}`;
        return this.http.get<object[]>(url).pipe(tap(_ => console.log('TEST')));
    }

    public getCandidateFilings(id: string): Observable<object[]> {
        const url = `${this.urlFilings1}${id}${this.urlFilings2}`;
        return this.http.get<object[]>(url).pipe(tap(_ => console.log('TEST')));
    }

    public getCandidateCommittee(id: string): Observable<object[]> {
        const url = `${this.urlCommitte}${id}${this.urlCommitte2}`;
        return this.http.get<object[]>(url).pipe(tap(_ => console.log('TEST')));
    }

    public getElections(years: string): Observable<object[]> {
        const url = `${this.urlElections}${years}`;
        return this.http.get<object[]>(url).pipe(tap(_ => console.log('TEST')));
    }

    /*
        public getDateElection(): Observable<object[]> {
            const url = `${this.urlDateElection}`;
            return this.http.get<object[]>(url).pipe(tap(_ => console.log( 'TEST' )), map(res =>  res['results']));
        }
     */
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            // this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }


}
